
OC__Property_reviews = {
	
	init : function()
	{
		// Check for reviews wrappers.
		if( jQuery('[data-type="sb-reviews"]').length )
		{
			OC__Property_reviews.load_data();
		}
		
		// Initialise the Add Review form.
		OC__Property_reviews.init_form_ui();

		// Respond to AJAX property list data received.
		jQuery(document).on('oc_reviews_ajax_html_result',function(event,pm_options){
			// Initialise UI.
			var config = {};
			config.html = pm_options.html;
			OC__Property_reviews.init_ui(config);
		});
	}
	,
	init_ui: function( pm_config = {} )
	{
		var html = (typeof pm_config.html !== 'undefined') ? pm_config.html : 'No Data';

		// Load HTML.
		jQuery('[data-type="sb-reviews"]').html(html);

		// Setup collapse buttons.
		jQuery('.oc--reviews .oc-control-list .oc-collapse > button').click(function(event){
			var state = jQuery(this).closest('.oc-sb-reviews').attr('data-collapse');
			if(state == 'closed')
			{
				jQuery(this).text('View Less');
				jQuery(this).closest('.oc-sb-reviews').attr('data-collapse','open');
			}
			else if(state == 'open')
			{
				jQuery(this).text('View More');
				jQuery(this).closest('.oc-sb-reviews').attr('data-collapse','closed');
			}
		});
	}
	,
	init_form_ui: function()
	{
		// Disable appropriate form fields.
		jQuery('.gfield.oc-readonly').each(function(pm_index){
			// Set readonly attribute on form elements.
			jQuery(this).find('input').attr("readonly","readonly");
			jQuery(this).find('select').attr("disabled","disabled");
		});
	}
	,
	load_data: function( pm_options )
	{
		// Track response
		var response = {};
		response.success = false;
		response.error = '';
		response.config = {};
		response.config.data = {};
		
		// Check for our on-page parameter object.
		if(typeof oc__oncloud_settings === 'undefined')
		{
			response.error = 'Parameter object not found';
			return(response);
		}
		
		var property_id = jQuery('[data-type="sb-reviews"]').attr('data-property-id');
		//var modules = jQuery('[data-type="sb-reviews"]').attr('data-modules');
		
		// Assemble the endpoint.
		//var data_url = oc__oncloud_settings.url + 'library/property/services/get-sb-review-detail-html.php';

		// Data URL - AJAX Admin URL stored in page config object.
		var data_url = oc__system_settings.ajax_url;
		
		var data_options = {};
		data_options.action = 'oc_reviews_html';
		//data_options.abn = oc__oncloud_settings.property_options.client.abn;
		//data_options.lic1 = oc__oncloud_settings.property_options.client.sh_licence_1;
		data_options.property_id = property_id;//'311564643817227723000RK';
		
		/*
		jQuery.ajax({
			url: data_url,
			type: 'POST',
			data: JSON.stringify(data_options),
			contentType: 'text/plain; charset=utf-8',
			dataType: 'json',
			success: function(result){
					
				if( result.success )
				{
					// Initialise UI.
					var config = {};
					config.html = result.html;
					//OC__Property_reviews.init_ui(config);
				}
				else
				{
					response.error = result.error;
				}
			}
			,
			error: function(request, status, error){
		        //if(status == 'error')
		        //{
			        //response.error = 'XHR error';
		        //}
		    }
		});
		*/

		// Admin AJAX call.
		jQuery.ajax({
			type: 'post',
			dataType: 'json',
			url: data_url,
			data: data_options,
			success: function(result){
				if( result.success )
				{
					// Emit event for elements to respond to.
					var options = {};
					options.html = result.data.html;
					jQuery(document).trigger('oc_reviews_ajax_html_result',options);
				}
				else
				{
					response.error = result.error;
				}
			}
		});	
	}
}

jQuery(document).ready(function(jQuery){
	
	OC__Property_reviews.init();
	
});